import Config from "../Config";

export const RestService = {
    get: async function(url, headers, signal) {
        headers["Content-Type"] = "application/json";
        headers["marvel"] = Config.marvel;
        headers["touch-token"] = localStorage.getItem('acumen.session');
        headers["app-version"] = global.appVersion;
        headers["platform"] = 'web';
        return fetch(url, {
            method: "GET",
            headers: headers,
            signal
        })
        .then(response => {
            if (response.status === 401) {
                localStorage.removeItem('acumen.user');
                localStorage.removeItem('acumen.session');
                localStorage.removeItem("acumen.branch");
                window.location.reload(true);
                const error = (response && response.message) || response.statusText;
                return Promise.reject(error);
            }
            
            return response;
        });
    },
    delete: async function(url, headers) {
        headers["Content-Type"] = "application/json";
        headers["marvel"] = Config.marvel;
        headers["touch-token"] = localStorage.getItem('acumen.session');
        headers["app-version"] = global.appVersion;
        headers["platform"] = 'web';
         return fetch(url, {
             method: "DELETE",
             headers: headers
         });
    },
    post:  async function(url, headers, body) {
        headers["Content-Type"] = "application/json";
        headers["marvel"] = Config.marvel;
        headers["touch-token"] = localStorage.getItem('acumen.session');
        headers["app-version"] = global.appVersion;
        headers["platform"] = 'web';
         return fetch(url, {
             method: "POST",
             headers: headers,
             body: body ? JSON.stringify(body) : null
         })
         .then(response => {
            if (response.status === 401) {
                localStorage.removeItem('acumen.user');
                localStorage.removeItem('acumen.session');
                localStorage.removeItem("acumen.branch");
                window.location.reload(true);
                const error = (response && response.message) || response.statusText;
                return Promise.reject(error);
            }
            return response;
        });
    },
    postFormData:  async function(url, headers, body) {
        headers["enctype"] = "multipart/form-data";
        headers["marvel"] = Config.marvel;
        headers["touch-token"] = localStorage.getItem('acumen.session');
        headers["app-version"] = global.appVersion;
        headers["platform"] = 'web';
         return fetch(url, {
             method: "POST",
             headers: headers,
             body: body
         })
         .then(response => {
            if (response.status === 401) {
                localStorage.removeItem('acumen.user');
                localStorage.removeItem('acumen.session');
                localStorage.removeItem("acumen.branch");
                window.location.reload(true);
                const error = (response && response.message) || response.statusText;
                return Promise.reject(error);
            }
            return response;
        });
    }
};
